import {
	type Navigation,
	createBrowserNavigationUrl,
	route
} from "client/Navigation";
import { navigateTo } from "client_legacy/ndaw/navigator";
import type { WorkspacePageRouteParams } from "./Workspace";

export const workspaceRouting = {
	page: route``,
	pageWithSpace: route<Required<Pick<WorkspacePageRouteParams, "spaceId">>>`/Space/${"spaceId"}`
};

export function getWorkspacePageNavigation(spaceId: number | undefined): Navigation {
	if (spaceId === undefined) {
		return workspaceRouting.page({});
	}

	return workspaceRouting.pageWithSpace({
		routeParams: {
			spaceId: `${spaceId}`
		}
	});
}

export function navigateToWorkspace(spaceId?: number): void {
	const workspaceUrl: string = createSpaceUrl(spaceId);
	navigateTo(workspaceUrl);
}

function createSpaceUrl(spaceId: number | undefined): string {
	const navigation: Navigation = getWorkspacePageNavigation(spaceId);
	return createBrowserNavigationUrl(navigation);
}
